import { Component, OnInit } from '@angular/core';
import { E5coreUiAssignUserBaseComponent } from './e5core-ui-work-assign-user-base';

@Component({
  selector: 'e5core-ui-work-assign-user-bootstrap',
  templateUrl: './e5core-ui-work-assign-user-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-assign-user-bootstrap.component.css'],
  providers: [ {provide: E5coreUiAssignUserBaseComponent, useExisting: E5coreUiAssignUserBootstrapComponent }]
})
export class E5coreUiAssignUserBootstrapComponent extends E5coreUiAssignUserBaseComponent implements OnInit{
}